import { lazy } from 'react';

// 页面列表
const HomeManager = lazy(() => import('pages/homeManager'));
// 页面配置
const HomeSetting = lazy(() => import('pages/homeSetting'));

const router = {
    path: '/home',
    name: '页面管理',
    icon: 'home',
    permission: 108,
    children: [
        {
            path: 'manager',
            name: '页面列表',
            icon: 'home',
            permission: 10801,
            component: HomeManager,
        },
        {
            path: 'setting',
            name: '页面配置',
            icon: '_space',
            permission: 10801,
            hideInMenu: true,
            component: HomeSetting,
        },
    ],
};

// 首页管理模块路由
export default router;
